import React from "react";
import styles from "./index.module.css";
import dollars from "../../icons/Dollars.svg";

const TopProofArrow = () => {
  return (
    <div className={styles.topArrow}>
      <div className="arrow">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="965"
          height="342"
          viewBox="0 0 965 342"
          fill="none"
        >
          <path
            d="M0.939331 10.9418C0.353577 11.5276 0.353577 12.4773 0.939331 13.0631L10.4852 22.6091C11.071 23.1949 12.0208 23.1949 12.6066 22.6091C13.1923 22.0234 13.1923 21.0736 12.6066 20.4878L4.12134 12.0025L12.6066 3.51726C13.1924 2.93148 13.1924 1.98173 12.6067 1.39594C12.0209 0.810151 11.0711 0.810145 10.4854 1.39593L0.939331 10.9418ZM961.5 20.0077L961.5 342.002L964.5 342.002L964.5 20.0077L961.5 20.0077ZM955 10.5077L2 10.5025L2 13.5025L955 13.5077L955 10.5077ZM964.5 20.0077C964.5 14.7611 960.247 10.5078 955 10.5077L955 13.5077C958.59 13.5078 961.5 16.4179 961.5 20.0077L964.5 20.0077Z"
            fill="#10C237"
          />
        </svg>
      </div>
      <div className={styles.dollars}>
        <img src={dollars} alt="dollars" />
      </div>
      <div className={styles.bottomArrow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="151"
          viewBox="0 0 24 151"
          fill="none"
        >
          <path
            d="M10.9393 150.063C11.5251 150.648 12.4749 150.648 13.0607 150.063L22.6066 140.517C23.1924 139.931 23.1924 138.981 22.6066 138.395C22.0208 137.81 21.0711 137.81 20.4853 138.395L12 146.881L3.51471 138.395C2.92893 137.81 1.97918 137.81 1.39339 138.395C0.807608 138.981 0.807608 139.931 1.3934 140.517L10.9393 150.063ZM10.4999 0.00195367L10.4999 3.10612L13.4999 3.10612L13.4999 0.00195258L10.4999 0.00195367ZM10.4999 9.31445L10.5 15.5228L13.5 15.5228L13.4999 9.31445L10.4999 9.31445ZM10.5 21.7311L10.5 27.9395L13.5 27.9395L13.5 21.7311L10.5 21.7311ZM10.5 34.1478L10.5 40.3561L13.5 40.3561L13.5 34.1478L10.5 34.1478ZM10.5 46.5645L10.5 52.7728L13.5 52.7728L13.5 46.5645L10.5 46.5645ZM10.5 58.9811L10.5 65.1895L13.5 65.1895L13.5 58.9811L10.5 58.9811ZM10.5 71.3978L10.5 77.6061L13.5 77.6061L13.5 71.3978L10.5 71.3978ZM10.5 83.8145L10.5 90.0228L13.5 90.0228L13.5 83.8145L10.5 83.8145ZM10.5 96.2311L10.5 102.439L13.5 102.439L13.5 96.2311L10.5 96.2311ZM10.5 108.648L10.5 114.856L13.5 114.856L13.5 108.648L10.5 108.648ZM10.5 121.064L10.5 127.273L13.5 127.273L13.5 121.064L10.5 121.064ZM10.5 133.481L10.5 139.689L13.5 139.689L13.5 133.481L10.5 133.481ZM10.5 145.898L10.5 149.002L13.5 149.002L13.5 145.898L10.5 145.898Z"
            fill="#10C237"
          />
        </svg>
      </div>
    </div>
  );
};

export default TopProofArrow;
